import React from 'react';
import { connect } from 'react-redux';

import get from 'lodash.get';
import cloneDeep from 'lodash/cloneDeep';

import FormbuilderText from './formbuilderFields/formbuilderText';
import FormbuilderTextArea from './formbuilderFields/formbuilderTextArea';
import FormbuilderDropdown from './formbuilderFields/formbuilderDropdown';
import FormbuilderCheckbox from './formbuilderFields/formbuilderCheckbox';
import FormbuilderDatePicker from './formbuilderFields/formbuilderDatePicker';
import FormbuilderPhoneNumber from './formbuilderFields/formbuilderPhoneNumber';
import FormbuilderAddress from './formbuilderFields/formbuilderAddress';
import FormbuilderGroupDivider from './formbuilderFields/formBuilderGroupDivider';
import FormbuilderConsent from "./formbuilderFields/formbuilderConsent";
import EmailField from './formElements/emailField';

import { isArrayWithItems } from '../../helpers/arrayHelper';
import { hasFormbuilderQuestions, getFormbuilderQuestions } from '../../helpers/formBuilderHelper';

import { nodeTypes, TYPE_DOES_NOT_EXIST, additionalAnswerValidation } from '../../constants/formbuilder';

export class FormbuilderAnswersContainer extends React.Component {
    constructor(props) {
        super(props);

        this.initAdditionalCheckboxInfo();
    }

    initAdditionalCheckboxInfo = () => {
        if (this.props.value && hasFormbuilderQuestions(this.props.value)) {
            const checkboxQuestions = getFormbuilderQuestions(this.props.value).filter(x => x.type === nodeTypes.CHECKBOX);
            let questionsModel;

            checkboxQuestions.forEach((question) => {
                if (question.additionalCheckboxInfo) {
                    return;
                }
                const options = this.getOptionsFromString(question.props.options);

                // if we don't have additionalCheckboxInfo in formBuilder structure, we will add it
                // additionalCheckboxInfo used for representing checkboxes states
                const additionalCheckboxInfo = [];

                if (options) {
                    options.forEach((option, index) => {
                        // set initial value for checkboxes
                        additionalCheckboxInfo[index] = false;
                    });
                }

                questionsModel = this.getNewQuestionsModel(this.getAnswerFromCheckboxInfo(additionalCheckboxInfo, options), question.identifier, additionalCheckboxInfo, questionsModel);
            });

            if (questionsModel) {
                this.props.onChange(questionsModel);
            }
        }
    }

    onChange = (value, identifier, additionalCheckboxInfo) => {
        this.props.onChange(this.getNewQuestionsModel(value || null, identifier, additionalCheckboxInfo));
    }

    onPhoneNumberChange = (value, identifier) => {
        this.props.onChange(this.getNewQuestionsModel(value, identifier, null));
    }

    getNewQuestionsModel = (newAnswer, identifier, additionalCheckboxInfo, value = this.props.value) => {
        const newModel = cloneDeep(value);

        if (hasFormbuilderQuestions(newModel)) {
            const currentQuestion = newModel.children[0].children.find(x => x.identifier === identifier);
            currentQuestion.answer = newAnswer;

            if (additionalCheckboxInfo) {
                currentQuestion.additionalCheckboxInfo = additionalCheckboxInfo;
            }
        }

        return newModel;
    }

    getAnswerFromCheckboxInfo = (checkboxInfo, options) => {
        if (options && options.length) {
            const answerOptions = options.map(item => {
                return checkboxInfo[item.index] === true ? item.text : '';
            });
            const checkedAnswerOptions = answerOptions.filter(x => x !== '');

            return checkedAnswerOptions && checkedAnswerOptions.length ? checkedAnswerOptions.join(', ') : undefined;
        }
    }

    hasComponentPropsOptions(componentProps) {
        return componentProps && componentProps.options && componentProps.options.length;
    }

    getAnswerComponents = () => {
        if (this.props.value && hasFormbuilderQuestions(this.props.value)) {
            const formBuilderQuestions = getFormbuilderQuestions(this.props.value);
            const components = formBuilderQuestions
                .filter(item => !item.props.hidden)
                .filter(item => {
                    const groupIdentifier = item.props.groupIdentifier;
                    const group = groupIdentifier && formBuilderQuestions.find(element => element.identifier === groupIdentifier);

                    return !group || group.answer !== true;
                })
                .map((item) => {
                    return this.getAnswerComponent(item);
                });

            return components.filter(x => x !== undefined);
        }
    }

    getAnswerComponent = (question) => {
        const { type, identifier } = question;
        const componentProps = this.getComponentProps(question)
        const { label, placeholder, inputSub, value, options, content, link, validation } = componentProps;

        switch (type) {
            case nodeTypes.TEXT_INPUT:
            case nodeTypes.ADDITIONAL_FIRST_NAME:
            case nodeTypes.ADDITIONAL_LAST_NAME:
                return (
                    <FormbuilderText onChange={(event, { value }) => this.onChange(value, identifier)}
                        key={identifier}
                        identifier={identifier}
                        label={label}
                        placeholder={placeholder}
                        inputSub={inputSub}
                        value={value}
                        validation={validation}
                        initialValidation={this.props.initialValidation} />
                );

            case nodeTypes.ADDRESS:
                return (
                    <FormbuilderAddress onChange={(address) => this.onChange(address, identifier)}
                        key={identifier}
                        identifier={identifier}
                        label={label}
                        placeholder={placeholder}
                        inputSub={inputSub}
                        value={value}
                        validation={validation}
                        initialValidation={this.props.initialValidation} />
                );


            case nodeTypes.DATE:
                return (
                    <FormbuilderDatePicker onChange={(date) => this.onChange(date, identifier)}
                        key={identifier}
                        identifier={identifier}
                        label={label}
                        placeholder={placeholder}
                        inputSub={inputSub}
                        value={value}
                        validation={validation}
                        initialValidation={this.props.initialValidation} />
                );

            case nodeTypes.ADDITIONAL_PHONE:
            case nodeTypes.PHONE:
                return (
                    <FormbuilderPhoneNumber onChange={(phone) => this.onPhoneNumberChange(phone, identifier)}
                        key={identifier}
                        identifier={identifier}
                        label={label}
                        placeholder={placeholder}
                        inputSub={inputSub}
                        value={value}
                        validation={validation}
                        organizationCountry={this.props.organizationCountry}
                        initialValidation={this.props.initialValidation} />
                );

            case nodeTypes.TEXT_AREA:
                return (
                    <FormbuilderTextArea onChange={(event, { value }) => this.onChange(value, identifier)}
                        key={identifier}
                        identifier={identifier}
                        label={label}
                        placeholder={placeholder}
                        inputSub={inputSub}
                        value={value}
                        validation={validation}
                        initialValidation={this.props.initialValidation} />
                );

            case nodeTypes.DROPDOWN:
                return (
                    <FormbuilderDropdown onChange={(event, { value }) => this.onChange(value, identifier)}
                        key={identifier}
                        identifier={identifier}
                        label={label}
                        placeholder={placeholder}
                        inputSub={inputSub}
                        value={value}
                        validation={validation}
                        options={options}
                        initialValidation={this.props.initialValidation} />
                );

            case nodeTypes.CHECKBOX:
                return (
                    <div key={identifier} className="field" id='formbuilder-checkbox'>
                        {this.getCheckboxesByOptions(componentProps, identifier)}
                        <div className="input-sub">{componentProps.inputSub}</div>
                    </div>
                );

            case nodeTypes.GROUP_DIVIDER:
                return (
                    <FormbuilderGroupDivider
                        key={identifier}
                        identifier={identifier}
                        label={label}
                        inputLabel="I'm not sure yet"
                        checked={value}
                        onChange={(event, { checked }) => this.onChange(checked, identifier)} />
                )

            case nodeTypes.ADDITIONAL_EMAIL:
                return <EmailField
                    key={identifier}
                    value={value}
                    label={label}
                    inputSub={inputSub}
                    validation={validation}
                    onChange={(value) => {
                        this.onChange(value, identifier)
                    }} />;

            case nodeTypes.CONSENT:
                return (
                    <FormbuilderConsent
                        key={identifier}
                        inputLabel={content}
                        link={link}
                        checked={!!value}
                        validation={validation}
                        onChange={(event, { checked }) => this.onChange(checked, identifier)} />
                );

            default:
                throw new Error(`${TYPE_DOES_NOT_EXIST}${type}`);
        }
    }

    getCheckboxesByOptions = (componentProps, identifier) => {
        if (!this.hasComponentPropsOptions(componentProps)) {
            return;
        }

        const checkboxes = componentProps.options.map((option, optionIndex) => {
            const label = optionIndex === 0 ? componentProps.label : '';
            const validation = optionIndex === 0 ? componentProps.validation : '';
            const question = this.getQuestionByIdentifier(identifier);
            // get checked state from additionalCheckboxInfo
            const checked = question && isArrayWithItems(question.additionalCheckboxInfo) && question.additionalCheckboxInfo[optionIndex];

            return (
                <FormbuilderCheckbox label={label}
                    key={identifier}
                    identifier={identifier}
                    optionindex={optionIndex}
                    inputLabel={option.text}
                    checked={checked}
                    validation={validation}
                    onChange={(event, { checked }) => this.onCheckboxChange(checked, identifier, optionIndex)} />
            )
        });

        return checkboxes;
    }

    getQuestionByIdentifier = (identifier) => {
        if (hasFormbuilderQuestions(this.props.value)) {
            return getFormbuilderQuestions(this.props.value).find(x => x.identifier === identifier);
        }

        return undefined;
    }

    onCheckboxChange = (checked, identifier, optionIndex) => {
        const question = this.getQuestionByIdentifier(identifier);

        if (question && isArrayWithItems(question.additionalCheckboxInfo)) {
            // get deep clone to avoid implicit props changing
            let clonedAdditionalCheckboxInfo = cloneDeep(question.additionalCheckboxInfo);
            clonedAdditionalCheckboxInfo[optionIndex] = checked;

            const options = this.getOptionsByIdentifier(identifier);
            const checkboxAnswer = this.getAnswerFromCheckboxInfo(clonedAdditionalCheckboxInfo, options);

            this.props.onChange(this.getNewQuestionsModel(checkboxAnswer, identifier, clonedAdditionalCheckboxInfo));
        }
    }

    getOptionsByIdentifier = (identifier) => {
        if (hasFormbuilderQuestions(this.props.value)) {
            const componentProps = this.getComponentProps(getFormbuilderQuestions(this.props.value).find(x => x.identifier === identifier));

            if (this.hasComponentPropsOptions(componentProps)) {
                return componentProps.options;
            }
        }
    }

    getComponentProps(question) {
        if (!question) {
            return undefined;
        }

        const { type, props, answer } = question;
        const additionalValidation = additionalAnswerValidation[type];

        return {
            label: props.title,
            placeholder: props.placeholderText,
            inputSub: props.description,
            value: answer,
            options: this.getOptionsFromString(props.options),
            validation: {
                required: props.required,
                formbuilderAddressRequired: type === nodeTypes.ADDRESS && props.required ? true : undefined,
                ...additionalValidation
            }
        }
    }

    getOptionsFromString(optionsString) {
        if (!optionsString) {
            return;
        }
        const options = optionsString.split('\n').map((item, index) => ({
            value: item,
            text: item,
            index: index
        }));

        return options;
    }

    render() {
        if (!this.props.value) {
            return null;
        }

        const components = this.getAnswerComponents();

        if (!components || !components.length) {
            return null;
        }

        return components.map(component => {
            return component;
        });
    }
}

const mapState = (state) => {
    return {
        organizationCountry: get(state, 'page.campaign.organization.country')
    }
}

const FormbuilderAnswers = connect(mapState)(FormbuilderAnswersContainer);
export default FormbuilderAnswers;